<template>
  <v-container class="pa-0">
    <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
      <page-header-title :title="page_title"></page-header-title>

      <v-spacer></v-spacer>

      <action-button type="back" @click="$router.go(-1)" />

      <router-link
        :to="{
          path: BACKEND_URL + '/classes/edit/' + classes.id,
          props: { id: classes.id }
        }"
        v-if="$can('class-edit')"
      >
        <action-button type="edit" />
      </router-link>

      <action-button type="delete" @click="del(classes.id)" v-if="$can('class-delete')" />
    </v-app-bar>

    <v-form ref="form">
      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg4 md4 sm6 xs12>
                <v-text-field v-model="classes.name" :label="$t('classes.name')" readonly autocomplete="new-password"></v-text-field>
              </v-flex>
              <v-flex lg4 md4 sm6 xs12>
                <v-text-field
                  v-model="coursetypegroup.full_name"
                  :label="$t('classes.coursetypegroup_id')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg4 md4 sm6 xs12>
                <v-text-field
                  v-model="coursetype.fullname"
                  :label="$t('classes.coursetype_id')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg4 md4 sm6 xs12>
                <v-text-field
                  name="classes.duration"
                  v-model="classes.duration"
                  :label="$t('classes.duration')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg4 md4 sm6 xs12>
                <v-text-field
                  name="classes.duration_type"
                  :value="this.$dd_classes_duration_type(classes.duration_type)"
                  :label="$t('classes.duration_type')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg4 md4 sm6 xs12>
                <v-text-field
                  name="classes.status"
                  :value="this.$dd_classes_status(classes.status)"
                  :label="$t('classes.status')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "ClassForm",

  props: ["id"],

  data() {
    return {
      page_title: "",
      classes: {},
      coursetype: {},
      coursetypegroup: {},
      dictionary: {
        attributes: {
          "classes.name": this.$t("classes.name"),
          "classes.duration": this.$t("classes.duration"),
          "classes.status": this.$t("classes.status"),
          "classes.duration_type": this.$t("classes.duration_type")
        }
      }
    }
  },

  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    }
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  created() {
    axios
      .get(this.API_URL + "class/" + this.id)
      .then((res) => {
        this.classes = res.data.data
        this.coursetypegroup = this.classes.coursetypegroup
        this.coursetype = this.classes.coursetype

        this.page_title = this.$t("classes.view_classes", {
          name: this.classes.name,
          duration: this.classes.duration,
          duration_type: this.classes.duration_type,
          status: this.classes.status
        })
      })
      .catch((err) => console.log(err))
  },

  methods: {
    save() {
      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            let vm = this

            if (!this.classes.id) {
              // Create
              axios
                .post(this.API_URL + "class", {
                  name: this.classes.name,
                  duration: this.classes.duration,
                  duration_type: this.classes.duration_type,
                  status: this.classes.status
                })
                .then((res) => {
                  if (typeof res.data.errors !== "undefined") {
                  } else {
                    if (res.data.data.id) {
                      vm.$router.push(this.BACKEND_URL + "/classes")
                      vm.$awn.success(vm.$t("global.create_success"))
                    }
                  }
                })
                .catch((err) => console.log(err))
            } else {
              // Update
              axios
                .put(this.API_URL + "class", {
                  id: this.classes.id,
                  name: this.classes.name,
                  duration: this.classes.duration,
                  duration_type: this.classes.duration_type,
                  status: this.classes.status
                })
                .then((res) => {
                  vm.$awn.success(vm.$t("global.update_success"))
                })
                .catch((err) => console.log(err))
            }
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    },

    del(id) {
      let vm = this

      this.$awn.confirm(
        this.$t("global.delete_message"),
        () => {
          return
        },
        () => {
          axios
            .delete(this.API_URL + "class/" + id)
            .then((res) => {
              vm.$router.push(this.BACKEND_URL + "/classes")
              vm.$awn.success(vm.$t("global.delete_success"))
            })
            .catch((err) => console.log(err))
        },
        {
          labels: {
            confirm: "",
            confirmCancel: this.$t("global.yes"),
            confirmOk: this.$t("global.no")
          }
        }
      )
    }
  }
}
</script>

<style scoped></style>
